export const TALLY_SHEET_COLUMNS = [
  {
    width: 100,
    field: 'no',
    title: 'Action',
    fieldType: 'action'
  },
  {
    width: 200,
    field: 'product_name',
    title: 'Material',
    fieldType: 'select'
  },
  {
    width: 100,
    field: 'quantity',
    title: 'Quantity',
    fieldType: 'numberinput'
  },
  {
    width: 250,
    field: 'uom_quantity',
    title: 'UOM',
    fieldType: 'select',
  },
  {
    width: 200,
    field: 'start_date',
    title: 'Start',
    fieldType: 'datetime'
  },
  {
    width: 200,
    field: 'end_date',
    title: 'Finish',
    fieldType: 'datetime'
  },
  {
    width: 200,
    field: 'vehicle_number',
    title: 'Unit ID Number',
    fieldType: 'textinput'
  },
  {
    width: 200,
    field: 'driver_name',
    title: 'Person in Charge',
    fieldType: 'textinput'
  },
  {
    width: 200,
    field: 'remarks',
    title: 'Remarks',
    fieldType: 'textinput'
  }
]
